import React, { FC } from 'react';
import { Drawer as AntdDrawer } from 'antd';
import { DrawerProps as AntdDrawerProps } from 'antd/lib/drawer';
import styled from 'styled-components';

import layout from '~/hooks/layout';
import { CloseIcon } from '~/img';
import { useDirection } from '../hooks';

export type DrawerProps = Omit<AntdDrawerProps, 'width'>;

const Drawer: FC<DrawerProps> = (props) => {
  const { size, ...rest } = props;
  const isMobile = layout.useIsMobile();
  const [dir] = useDirection();

  return (
    <StyledDrawer
      destroyOnClose
      width={isMobile ? '100vw' : size === 'large' ? 780 : 380}
      height="100%"
      // placement={isMobile ? 'bottom' : 'right'}
      closeIcon={<CloseIcon />}
      dir={dir}
      {...rest}
    />
  );
};

interface StyledModalProps extends AntdDrawerProps {
  dir: 'ltr' | 'rtl';
}

const StyledDrawer = styled<FC<StyledModalProps>>(AntdDrawer)`
  .ant-drawer-close {
    margin-right: ${({ dir }) => (dir === 'ltr' ? 0 : 'unset')};
    margin-left: ${({ dir }) => (dir === 'ltr' ? 0 : 'unset')};
  }
`;

export default Drawer;
